import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { PortfoliosDataGrid } from '../../organisms';
import { PageTemplate } from '..';

const PortfolioTemplate = memo(props => {
  const { initialState, state, ...restDataGridProps } = props.dataGridProps;

  return (
    <PageTemplate
      title={props.title}
      subtitle={props.subtitle}
      scrollable={true}
      headerRenderActions={props.headerRenderActions}>
      <PortfoliosDataGrid
        {...restDataGridProps}
        initialState={{
          ...initialState,
          density: 'comfortable'
        }}
        state={state}
      />
    </PageTemplate>
  );
});

PortfolioTemplate.propTypes = {
  data: PropTypes.array,
  isFetching: PropTypes.bool,
  readData: PropTypes.func,
  title: PropTypes.string,
  subtitle: PropTypes.string
};

export default PortfolioTemplate;
